var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobiliti2Yellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 57,
    viewBox: "0 0 71 57",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2932 12.2382C21.0599 -3.9101 0.494144 -7.84953 0.494141 24.0129C0.494136 73.1307 37.9942 52.7527 57.4608 47.6516C82.4445 41.1048 68.5108 22.3015 50.2932 12.2382Z",
    fill: "#ffc12f",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5322 42.9366L34.4944 27.4976L36.3646 31.0604L46.3156 21.8078M48.722 19.5703L48.6212 19.664",
    stroke: "#ffc12f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#55a12e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1582 44.7705L13.9338 48.3967L17.8123 49.1219",
    stroke: "#ffc12f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#55a12e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.725 47.2948L28.1256 49.3281C29.3042 51.0392 31.7596 51.5244 33.5848 50.407C34.8935 49.6057 36.5896 49.6057 37.8982 50.407C39.7234 51.5244 42.1841 51.0315 43.3628 49.3203C44.2076 48.0939 45.7591 47.4466 47.3051 47.6812C49.4594 48.0081 51.4901 46.6198 51.8216 44.6137C52.0596 43.1726 53.1952 41.9873 54.7108 41.6134C56.8238 41.0921 58.0733 39.0571 57.5024 37.095C57.0922 35.6853 57.613 34.1731 58.8348 33.2553C60.5404 31.974 60.8009 29.6459 59.4192 28.0628C58.4286 26.928 58.2531 25.3491 58.9689 24.0479C59.9659 22.2356 59.1949 20.006 57.2428 19.0848C55.8433 18.4243 54.9969 17.0447 55.0846 15.5877C55.2065 13.5603 53.5306 11.8094 51.3493 11.7104C49.7842 11.6393 48.4099 10.7021 47.8565 9.33888C47.0855 7.43945 44.789 6.47685 42.755 7.21512C41.2959 7.74477 39.6369 7.41569 38.5366 6.37908C36.9994 4.93093 34.4836 4.93093 32.9464 6.37908C31.8461 7.41569 30.1872 7.74477 28.728 7.21512C26.6941 6.47685 24.3976 7.43945 23.6266 9.33888C23.0733 10.7021 21.6988 11.6393 20.1338 11.7104C17.9525 11.8094 16.2765 13.5603 16.3985 15.5877C16.4861 17.0447 15.6398 18.4243 14.2402 19.0848C12.2881 20.006 11.5171 22.2356 12.5141 24.0479C13.23 25.3491 13.0559 26.9263 12.0654 28.0611C10.6815 29.6466 10.9447 31.9755 12.6529 33.2588L14.6585 34.7654",
    stroke: "#ffc12f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#55a12e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.806 28.8743C47.806 35.3882 42.1579 40.6689 35.1906 40.6689M22.5752 28.8743C22.5752 22.3602 28.2233 17.0796 35.1906 17.0796",
    stroke: "#ffc12f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#55a12e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiliti2Yellow);
export default __webpack_public_path__ + "static/media/mobiliti_2_yellow.1d1833a517a3686bd974722744826c6c.svg";
export { ForwardRef as ReactComponent };